import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-10 md:mb-14">
          <div>
            <span className="text-xs font-medium text-foreground-500 tracking-widest uppercase mb-2 block">
              分类浏览
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              探索丰富题材
            </h2>
            <p className="font-heading text-3xl md:text-4xl font-light italic text-secondary-500 mt-1">
              找到你的最爱
            </p>
          </div>
          <Link
            to="/category/lian-ai"
            className="hidden lg:inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer mt-4 lg:mt-0"
          >
            全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group block rounded-lg overflow-hidden cursor-pointer"
            >
              <div
                className={`relative aspect-[3/4] bg-gradient-to-br ${cat.color} flex items-center justify-center overflow-hidden`}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent"></div>
                <span className="font-heading text-4xl md:text-5xl font-bold text-foreground-800/15 select-none transition-transform duration-300 group-hover:scale-110">
                  {cat.name}
                </span>
              </div>
              <div className="bg-white py-3 px-3">
                <h4 className="font-semibold text-foreground-950 text-sm mb-0.5">{cat.name}</h4>
                <p className="text-foreground-500 text-xs">{cat.count.toLocaleString()}+ 部作品</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 lg:hidden">
          <Link
            to="/category/lian-ai"
            className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer"
          >
            全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}